module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "africa-network"
  }, [_c('div', {
    staticClass: "africa-network__content"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "africa-network__col col-l-4 col-m-12",
    domProps: {
      "innerHTML": _vm._s(_vm.first)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "africa-network__col col-l-4 col-m-12",
    domProps: {
      "innerHTML": _vm._s(_vm.second)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "africa-network__col africa-network__col--third col-l-4 col-m-12",
    domProps: {
      "innerHTML": _vm._s(_vm.third)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-622e9b82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AfricaNetwork.vue
// module id = 345
// module chunks = 0